export default "__VITE_ASSET__vd3rCOmd__"